import React, { useEffect, useState, useMemo } from 'react'
import ClipLoader from "react-spinners/ClipLoader";
import { Register as APIRegister } from '../api/auth'
import { Formik, Field } from "formik";
import * as Yup from "yup";
import { Form, Alert } from 'react-bootstrap'
import countryList from 'react-select-country-list'

const schema = Yup.object().shape({
    EmailAddress: Yup.string()
        .required("Email is a required field")
        .email("Invalid email format"),
    FirstName: Yup.string()
        .required("First Name is a required field"),
    LastName: Yup.string()
        .required("Last Name is a required field"),
    Password: Yup.string()
        .required("Password is a required field").min(8, 'Password should be 8 characters minimum.'),
    CompanyName: Yup.string()
        .required("Company is a required field"),
    confirmPassword: Yup.string()
        .oneOf([Yup.ref("Password"), null], "Passwords must match")
        .required("Confirm Password is a required field"),
        
    Country: Yup.string().test("valid", "Please select a Country", (value) => {
        if (!value || value == "Select...") {
            return false;
        }
        else {
            return true;
        }
    }),
    
    TelephoneNumber: Yup.string().required("Phone Number is a required field"),
    acceptTOS: Yup.bool().oneOf([true], "You must accept the Terms and Conditions").required()
});


export default function Register(props) {

    const [registerError, setRegisterError] = useState(null);
    const [submitting, setSubmitting] = useState(false);
    const countries = useMemo(() => countryList().getData(), [])


    return (
        <>

            <Formik
                validationSchema={schema}
                initialValues={{ EmailAddress: "", Password: "", confirmPassword: "", FirstName: "", LastName: "", CompanyName: "", TelephoneNumber: "", acceptTOS: false }}
                onSubmit={async (values) => {
                    setSubmitting(true);
                    try {

                        let _register = await APIRegister({ ...values });
                        const queryParams = new URLSearchParams(window.location.search);
                        window.location.href = queryParams.get(`return_url`) ?? `/my-account`;
                    } catch (ex) {
                        setRegisterError(ex.message ?? `There was an issue registering.  Please try again later.`);
                    }
                    finally {
                        setSubmitting(false);
                    }


                }}
            >
                {({
                    values,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                }) => (
                    <div className="register">
                        <h2>Register</h2>
                        <div className="form">
                            {registerError && <Alert transition={null} variant={'danger'}>{registerError}</Alert>}
                            <Form noValidate onSubmit={handleSubmit}>
                                
                                <Form.Row>
                                    <Form.Group controlId="Country" className={`col-md-10`}>
                                        <Form.Label>Country/Region</Form.Label>
                                        <Form.Control as="select" value={values.Country} name={"Country"} onChange={(e) => {
                                            handleChange(e);
                                        }} onBlur={handleBlur} isInvalid={errors.Country}>
                                            <option val="">Select...</option>
                                            {
                                                countries.map(country => {
                                                    return <option value={country.value} key={country.value}>{country.label}</option>
                                                })
                                            }
                                        </Form.Control>
                                        <Form.Control.Feedback type="invalid">
                                            {errors.Country}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                </Form.Row>
                                
                                <Form.Group controlId="EmailAddress" className={`col-md-10`}>
                                    <Form.Label>Business Email Address</Form.Label>
                                    <Form.Control type="email" value={values.EmailAddress} placeholder={`Business Email Address`} name={"EmailAddress"} onChange={handleChange} onBlur={handleBlur} isInvalid={errors.EmailAddress}></Form.Control>
                                    <Form.Control.Feedback type="invalid">
                                        {errors.EmailAddress && touched.EmailAddress && errors.EmailAddress}
                                    </Form.Control.Feedback>
                                </Form.Group>

                                <Form.Group controlId="FirstName" className={`col-md-10`}>
                                    <Form.Label>First Name</Form.Label>
                                    <Form.Control type='text' value={values.FirstName} placeholder={`First Name`} name={"FirstName"} onChange={handleChange} onBlur={handleBlur} isInvalid={errors.FirstName}></Form.Control>
                                    <Form.Control.Feedback type="invalid">
                                        {errors.FirstName && touched.FirstName && errors.FirstName}
                                    </Form.Control.Feedback>
                                </Form.Group>

                                <Form.Group controlId="LastName" className={`col-md-10`}>
                                    <Form.Label>Last Name</Form.Label>
                                    <Form.Control type='text' value={values.LastName} placeholder={`Last Name`} name={"LastName"} onChange={handleChange} onBlur={handleBlur} isInvalid={errors.LastName}></Form.Control>
                                    <Form.Control.Feedback type="invalid">
                                        {errors.LastName && touched.LastName && errors.LastName}
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group controlId="CompanyName" className={`col-md-10`}>
                                    <Form.Label>Company</Form.Label>
                                    <Form.Control type='text' value={values.CompanyName} placeholder={`Company Name`} name={"CompanyName"} onChange={handleChange} onBlur={handleBlur} isInvalid={errors.CompanyName}></Form.Control>
                                    <Form.Control.Feedback type="invalid">
                                        {errors.CompanyName && touched.CompanyName && errors.CompanyName}
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Row>
                                    <Form.Group controlId="TelephoneNumber" className={`col-md-10`}>
                                        <Form.Label>Phone</Form.Label>
                                        <Form.Control value={values.TelephoneNumber} placeholder={`Phone Number`} name={"TelephoneNumber"} onChange={handleChange} onBlur={handleBlur} isInvalid={errors.TelephoneNumber}></Form.Control>
                                        <Form.Control.Feedback type="invalid">
                                            {errors.TelephoneNumber && touched.TelephoneNumber && errors.TelephoneNumber}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                </Form.Row>
                                <Form.Group controlId="Password" className={`col-md-10`}>
                                    <Form.Label>Password</Form.Label>
                                    <Form.Control type='Password' value={values.Password} placeholder={`Password`} name={"Password"} onChange={handleChange} onBlur={handleBlur} isInvalid={errors.Password}></Form.Control>
                                    <Form.Control.Feedback type="invalid">
                                        {errors.Password && touched.Password && errors.Password}
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group controlId="confirmPassword" className={`col-md-10`}>
                                    <Form.Label>Confirm Password</Form.Label>
                                    <Form.Control type='Password' value={values.confirmPassword} placeholder={`Confirm Password`} name={"confirmPassword"} onChange={handleChange} onBlur={handleBlur} isInvalid={errors.confirmPassword}></Form.Control>
                                    <Form.Control.Feedback type="invalid">
                                        {errors.confirmPassword && touched.confirmPassword && errors.confirmPassword}
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group controlId="acceptTOS" className={`col-md-10`}>
                                    <Form.Check type={`checkbox`}>
                                        <Form.Check.Input type={`checkbox`} isInvalid={errors.acceptTOS} onChange={handleChange} onBlur={handleBlur} />
                                        <Form.Check.Label>I accept the <a href='/legal/tos'>Terms and Conditions</a></Form.Check.Label>
                                        <Form.Control.Feedback type="invalid">
                                            {errors.acceptTOS}
                                        </Form.Control.Feedback>
                                    </Form.Check>
                                </Form.Group>


                                <button type="submit" class={`gc-btn primary-action`}>Create an Account {submitting && <ClipLoader size={`18`} color={`#fff`} />}</button>


                            </Form>
                        </div>
                        <div className={`register-opt-text`}>
                            <p>We value your privacy and you have complete control over any information submitted. For more information see our <a href='/legal/privacy-policy'>privacy policy</a>.</p>
                        </div>
                    </div>
                )}
            </Formik>
        </>
    );

}